import { RosterAttendeeType } from "amazon-chime-sdk-component-library-react";
import { VideoMeetingRoster } from "./VideoMeetingRoster";
import { useVideoRoster } from "@platform/store";

export function VideoMeetingRosterContainer() {
  const roster = useVideoRoster();
  const attendees = Object.values(roster) as RosterAttendeeType[];

  return <VideoMeetingRoster roster={attendees} />;
}

export default VideoMeetingRosterContainer;
